import * as React from "react";
import "../../pages/forgetPassword/forgotpassword.css";

import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Link } from "react-router-dom";
import { useResetPassword } from "./customHook";

function ResetPassword() {
  const { register, handleSubmit, errors, onSubmit } = useResetPassword();

  return (
    <>
      <Container maxWidth={"xl"} className="page-header py-4 breadcrumb-bg">
        <h1 className="text-center display-6 breadcrumb-h1">Reset Password</h1>
        <ol className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/login">Login</Link>
          </li>
          <li className="breadcrumb-item active">Devotee Reset Password</li>
        </ol>
      </Container>
      <Container className="py-5">
        <Grid className="text-center mb-4">
          <h6 className="section-title text-center text-primary text-uppercase title-tl">
            Devotee
          </h6>
          <h1 className="mb-3">
            <span className="text-secundary">Reset Password</span>
          </h1>
        </Grid>
        <Grid className="row">
          <Container component="main" maxWidth="sm">
            <CssBaseline />
            <Box
              sx={{
                marginTop: 2,
              }}
            >
              <Box
                component="form"
                noValidate
                sx={{ mt: 3 }}
                onSubmit={handleSubmit(onSubmit)}
              >
                <Grid container>
                  <Grid item xs={12}>
                    <TextField
                      {...register("password")}
                      fullWidth
                      required
                      id="password"
                      label="New Password"
                      name="password"
                      className="mb-3"
                      error={!!errors?.password?.message}
                      helperText={errors?.password?.message}
                    />
                    <TextField
                      {...register("confirm_password")}
                      fullWidth
                      required
                      id="confirm_password"
                      label="Confirm Password"
                      name="confirm_password"
                      error={!!errors?.confirm_password?.message}
                      helperText={errors?.confirm_password?.message}
                    />
                  </Grid>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ mt: 3, mb: 2, p: 2 }}
                  >
                    Submit
                  </Button>
                </Grid>
              </Box>
            </Box>
          </Container>
        </Grid>
      </Container>
    </>
  );
}

export default ResetPassword;
